module.exports = __webpack_public_path__ + "static/sport/login-1.40bd644.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ldp/form/login-1.png
// module id = mzRT
// module chunks = 0